import { useQuery } from '@tanstack/react-query';

import {
  getDailyFinancials,
  getDashboardKpis,
  getPendingOrders,
  getRevenueByType,
  getRevenueTrend
} from '../apis/dashboard';
import { DailyFinancialsParams, DateRangeParams, PendingOrdersParams, RevenueTrendParams } from '../types/dashboard';

// ── Query Keys ──

export const DASHBOARD_QUERY_KEYS = {
  kpis: (params: DateRangeParams) => ['dashboard', 'kpis', params] as const,
  dailyFinancials: (params: DailyFinancialsParams) => ['dashboard', 'dailyFinancials', params] as const,
  revenueByType: (params: DateRangeParams) => ['dashboard', 'revenueByType', params] as const,
  pendingOrders: (params?: PendingOrdersParams) => ['dashboard', 'pendingOrders', params] as const,
  revenueTrend: (params: RevenueTrendParams) => ['dashboard', 'revenueTrend', params] as const
};

// ── Hooks ──

export const useDashboardKpis = (params: DateRangeParams) =>
  useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.kpis(params),
    queryFn: () => getDashboardKpis(params)
  });

export const useDailyFinancials = (params: DailyFinancialsParams) =>
  useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.dailyFinancials(params),
    queryFn: () => getDailyFinancials(params)
  });

export const useRevenueByType = (params: DateRangeParams) =>
  useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.revenueByType(params),
    queryFn: () => getRevenueByType(params)
  });

export const usePendingOrders = (params?: PendingOrdersParams) =>
  useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.pendingOrders(params),
    queryFn: () => getPendingOrders(params)
  });

export const useRevenueTrend = (params: RevenueTrendParams) =>
  useQuery({
    queryKey: DASHBOARD_QUERY_KEYS.revenueTrend(params),
    queryFn: () => getRevenueTrend(params)
  });
